module.exports = "images/france-2.21edb496.png";